module.exports = __webpack_public_path__ + "img/download-blue.d94caefb.svg";